if(cf_subject != null) {
    let subject_field = document.getElementById('cf_subject');

    if(subject_field != null){
        document.getElementById('cf_subject').value = 'Neue ' + cf_subject + '-Anfrage';
    }
}